import { Modal, Badge, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getMerchProduct } from "../data/merchCatalog";

function formatDateTime(value) {
	if (!value) return "—";
	const d = new Date(value);
	if (Number.isNaN(d.getTime())) return "—";
	return d.toLocaleString();
}

function money(value) {
	return "₹" + (typeof value === "number" ? value.toFixed(2) : value);
}

const STATUS_VARIANT = {
	PAID: "success",
	PENDING: "warning",
	FAILED: "danger",
	USER_DROPPED: "secondary",
	CANCELLED: "dark",
};

export default function OrderDetailsModal({ order, onHide }) {
	return (
		<Modal show={!!order} onHide={onHide} size="lg" centered scrollable>
			{order && (
				<>
					<Modal.Header closeButton>
						<Modal.Title>
							Order {order.orderId}{" "}
							<Badge bg={STATUS_VARIANT[order.status] || "secondary"}>
								{order.status}
							</Badge>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<h6>Customer</h6>
						<div style={{ marginBottom: "1rem" }}>
							<div>
								<strong>
									<Link to={"/participant/" + order.pid}>
										{order.fName} {order.lName}
									</Link>
								</strong>{" "}
								(PID: {order.pid})
							</div>
							{order.email && (
								<div>
									<a href={"mailto:" + order.email}>{order.email}</a>
								</div>
							)}
							{order.college && <div>{order.college}</div>}
						</div>

						<h6>Items</h6>
						<div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "1rem" }}>
							{(order.items || []).map((item, idx) => {
								const product = getMerchProduct(item.productId);
								return (
									<div
										key={idx}
										style={{
											display: "flex",
											gap: "12px",
											alignItems: "center",
											border: "1px solid #ddd",
											borderRadius: "6px",
											padding: "8px",
										}}
									>
										{product?.image && (
											<img
												src={product.image}
												alt={item.name}
												style={{
													width: "56px",
													height: "56px",
													objectFit: "cover",
													borderRadius: "4px",
													flexShrink: 0,
												}}
											/>
										)}
										<div style={{ flex: 1 }}>
											<div>
												<strong>{item.name}</strong>
												{item.size ? ` (${item.size})` : ""} × {item.quantity}
											</div>
											<div style={{ fontSize: "0.85rem", color: "#555" }}>
												{money(item.unitPrice)} each
												{item.discountPerUnit > 0 && (
													<>
														{" "}
														(discount {money(item.discountPerUnit)}/unit,{" "}
														{item.discountSource})
													</>
												)}
											</div>
										</div>
										<div style={{ fontWeight: "bold" }}>{money(item.subtotal)}</div>
									</div>
								);
							})}
						</div>

						<Table size="sm" borderless style={{ maxWidth: "320px", marginLeft: "auto" }}>
							<tbody>
								{order.subtotalBeforeDiscount > 0 && (
									<tr>
										<td>Subtotal</td>
										<td className="text-end">{money(order.subtotalBeforeDiscount)}</td>
									</tr>
								)}
								{order.discountTotal > 0 && (
									<tr>
										<td>Discount</td>
										<td className="text-end">-{money(order.discountTotal)}</td>
									</tr>
								)}
								{order.deliveryCharge > 0 && (
									<tr>
										<td>Delivery</td>
										<td className="text-end">{money(order.deliveryCharge)}</td>
									</tr>
								)}
								<tr>
									<td>
										<strong>Total</strong>
									</td>
									<td className="text-end">
										<strong>{money(order.amount)}</strong>
									</td>
								</tr>
							</tbody>
						</Table>

						<h6>Fulfillment</h6>
						<div style={{ marginBottom: "1rem" }}>
							<div>
								Mode: <strong>{order.fulfillment}</strong>
							</div>
							<div>
								Contact: {order.contactName} ({order.contactPhone})
							</div>
							{order.fulfillment === "delivery" && order.address && (
								<div>
									Address: {order.address.line1}, {order.address.city},{" "}
									{order.address.state} - {order.address.pincode}
									{!order.address.pincodeVerified && (
										<Badge bg="warning" style={{ marginLeft: "6px" }}>
											Pincode unverified
										</Badge>
									)}
								</div>
							)}
						</div>

						<h6>Payment</h6>
						<div>
							<div>Created: {formatDateTime(order.createdAt)}</div>
							<div>Paid: {formatDateTime(order.paidAt)}</div>
							{order.cfPaymentId && <div>Cashfree Payment ID: {order.cfPaymentId}</div>}
							{order.paymentMethod && <div>Method: {order.paymentMethod}</div>}
						</div>
					</Modal.Body>
				</>
			)}
		</Modal>
	);
}
